import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import Cropper from 'cropperjs';

@Component({
	selector: 'kwo-image-cropper',
	templateUrl: './image-cropper.component.html',
	styleUrl: './image-cropper.component.scss',
	standalone: true,
	imports: [CommonModule, FaIconComponent],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageCropperComponent implements OnInit, AfterViewInit {

	cropper!: Cropper;
	sanitizedUrl: SafeUrl;

	constructor(
		public dialogRef: MatDialogRef<ImageCropperComponent>,
		@Inject(MAT_DIALOG_DATA) public image: string,
		private sanitizer: DomSanitizer
	) { }

	ngOnInit(): void {

		this.sanitizedUrl = this.sanitizer.bypassSecurityTrustUrl(this.image);
	}

	ngAfterViewInit() {

		this.initCropper();
	}

	initCropper() {

		const image = document.getElementById('image') as HTMLImageElement;
		this.cropper = new Cropper(image, {
			aspectRatio: 1,
			viewMode: 1,
			guides: false,
			zoomable: false,
			minCanvasWidth: 320,
			minCanvasHeight: 320
		});
	}

	crop() {

		const croppedCanvas = this.cropper.getCroppedCanvas({ maxWidth: 400, maxHeight: 400, fillColor: '#fff', imageSmoothingQuality: 'medium' });

		this.dialogRef.close(croppedCanvas.toDataURL());
	}

	reset() {

		this.cropper.clear();
		this.cropper.crop();
	}
}
